<template>
    <div class="section-box">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="用户管理" name="add">
                <el-row>
                    <el-col :span="12" style="text-align: left">
                        <el-form label-position="right" label-width="120px" ref="ruleForm" :rules="rules" :model="form" style="min-width: 700px;">
                            <el-form-item label="优惠券名称：" prop="Name">
                                <el-input size="medium" v-model="form.Name" placeholder="请输入优惠券名称"></el-input>
                            </el-form-item>
                            <el-form-item label="标题：">
                                <el-input size="medium" v-model="form.Title" placeholder="请输入标题" maxlength="8"></el-input>
                            </el-form-item>
                            <el-form-item label="类型：" prop="CouponType">
                                <el-select size="medium" v-model="form.CouponType" placeholder="请选择类型" clearable style="width: 100%;">
                                    <el-option :value="item.value" :label="item.label" v-for="(item, index) in COUPONS_TYPE.COUPONTYPE" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                            <template v-if="form.CouponType == 1">
                                <el-form-item label="使用权限：" prop="UsePermission">
                                    <el-select size="medium" v-model="form.UsePermission" placeholder="请选择使用权限" clearable style="width: 100%;">
                                        <el-option :value="0" label="无限制"></el-option>
                                        <el-option :value="6" label="仅自营企业专区"></el-option>
                                        <el-option :value="1" label="仅众包企业专区"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="使用范围：" prop="UseScope">
                                    <el-select size="medium" v-model="form.UseScope" placeholder="请选择适用范围" clearable style="width: 100%;">
                                        <el-option :value="1" label="服务费用"></el-option>
                                        <el-option :value="999" label="其它费用"></el-option>
                                        <el-option :value="2" label="加班费用"></el-option>
                                        <el-option :value="3" label="交通费用"></el-option>
                                        <el-option :value="4" label="住宿费用"></el-option>
                                        <el-option :value="5" label="总费用"></el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                            <el-form-item label="优惠方式：" prop="CouponMode">
                                <el-radio-group v-model="form.CouponMode" size="medium">
                                    <el-radio :label="1">满减</el-radio>
                                    <el-radio :label="2">折扣</el-radio>
                                    <el-radio :label="3">立减</el-radio>
                                </el-radio-group>
                                <div>
                                    <div class="coupans-way-item" v-if="form.CouponMode == 1">
                                        满
                                        <el-input
                                            class="way-item-input"
                                            size="medium"
                                            v-model="form.FullReduceLimitAmount"
                                            placeholder="多少"
                                            style="margin-right: 10px;"
                                        ></el-input>
                                        减
                                        <el-input
                                            class="way-item-input"
                                            size="medium"
                                            v-model="form.FullReduceOffAmount"
                                            placeholder="多少"
                                        ></el-input>
                                    </div>
                                    <div class="coupans-way-item" v-else-if="form.CouponMode == 2">
                                        折扣比率
                                        <el-input
                                            class="way-item-input"
                                            size="medium"
                                            v-model="form.DiscountRate"
                                            placeholder="请输入（0.01~0.99）"
                                            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                                            maxlength="4"
                                        ></el-input>
                                    </div>
                                    <div class="coupans-way-item" v-else-if="form.CouponMode == 3">
                                        立减
                                        <el-input
                                            class="way-item-input"
                                            size="medium"
                                            v-model="form.OffAmount"
                                            placeholder="多少"
                                        ></el-input>
                                    </div>
                                </div>
                            </el-form-item>
                            <h4 class="small-title">基本规则</h4>
                            <el-form-item label="发放方式：" prop="GiveOutMode">
                                <el-select size="medium" v-model="form.GiveOutMode" placeholder="请选择发放方式" clearable style="width: 100%;">
                                    <el-option :value="item.value" :label="item.label" v-for="(item, index) in COUPONS_TYPE.GIVEOUTMODE" :key="index"></el-option>
                            </el-select>
                            </el-form-item>
                            <el-form-item label="目标用户：" prop="TargetUser">
                                <el-radio-group v-model="form.TargetUser" size="medium">
                                    <el-radio :label="1">全部用户</el-radio>
                                    <el-radio :label="2">部分用户</el-radio>
                                </el-radio-group>
                                <div v-if="form.TargetUser == 2">
                                    <div class="coupans-way-item">
                                        <el-button size="mini" type="primary" icon="el-icon-plus" plain style="width: 182px;" @click="addDrawerBox(1)">添加个人用户</el-button>
                                        <el-button size="mini" type="primary" plain style="width: 122px;" @click="updownExcel(1)">导入个人Excel</el-button>
                                        <div class="tips-number" v-if="personalNumber != 0" @click="IsSelectedTrueFun(1)">已选择个人用户{{personalNumber}}位<span @click.stop="deleteCouponAccountFun(1)"><svg t="1614240680020" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="2103" width="16" height="16"><path d="M174.08 940.8a32 32 0 0 1-22.4-54.4l704-704a32 32 0 0 1 45.44 0 32 32 0 0 1 0 44.8l-704 704a32.64 32.64 0 0 1-23.04 9.6z" fill="#999999" p-id="2104"></path><path d="M878.08 940.8a31.36 31.36 0 0 1-22.4-9.6l-704-704a30.72 30.72 0 0 1 0-44.8 32 32 0 0 1 45.44 0l704 704a32 32 0 0 1 0 44.8 32.64 32.64 0 0 1-23.04 9.6z" fill="#999999" p-id="2105"></path></svg></span></div>
                                    </div>
                                    <div class="coupans-way-item">
                                        <el-button size="mini" type="primary" icon="el-icon-plus" plain style="width: 182px;" @click="addDrawerBox(2)">添加企业用户</el-button>
                                        <el-button size="mini" type="primary" plain style="width: 122px;" @click="updownExcel(2)">导入企业Excel</el-button>
                                        <div class="tips-number" v-if="enterpriseNumber != 0" @click="IsSelectedTrueFun(2)">已选择企业用户{{enterpriseNumber}}位<span @click.stop="deleteCouponAccountFun(2)"><svg t="1614240680020" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="2103" width="16" height="16"><path d="M174.08 940.8a32 32 0 0 1-22.4-54.4l704-704a32 32 0 0 1 45.44 0 32 32 0 0 1 0 44.8l-704 704a32.64 32.64 0 0 1-23.04 9.6z" fill="#999999" p-id="2104"></path><path d="M878.08 940.8a31.36 31.36 0 0 1-22.4-9.6l-704-704a30.72 30.72 0 0 1 0-44.8 32 32 0 0 1 45.44 0l704 704a32 32 0 0 1 0 44.8 32.64 32.64 0 0 1-23.04 9.6z" fill="#999999" p-id="2105"></path></svg></span></div>
                                    </div>
                                </div>
                            </el-form-item>
                            <template v-if="form.GiveOutMode == 1">
                                <el-form-item label="每人发放数量：" prop="EveryPeopleCount">
                                    <el-input size="medium" v-model.number="form.EveryPeopleCount" @blur="bigFiveFun" placeholder="请输入数量"></el-input>
                                </el-form-item>
                            </template>
                            <template v-else-if="form.GiveOutMode != 1 && form.GiveOutMode">
                                <el-form-item label="总数量" prop="TotalCount">
                                    <el-input size="medium" v-model.number="form.TotalCount" placeholder="请输入数量"></el-input>
                                </el-form-item>
                            </template>
                            <el-form-item v-if="form.GiveOutMode == 2" label="每人限领：" prop="EveryPeopleLimitCount">
                                <div class="parcel">
                                    <el-input size="medium" v-model="form.EveryPeopleLimitCount" placeholder="请输入限领次数"></el-input>
                                    <span>次</span>
                                </div>
                            </el-form-item>
                            <el-form-item label="有效期：" prop="EffectivityDateType">
                                <div class="coupans-way-item" style="margin-top: 0px;">
                                    <el-radio v-model="form.EffectivityDateType" :label="1" @change="EffectivityDateTypeRadio">
                                        固定日期
                                        <el-date-picker
                                            :disabled="isRadioValidDisabledTime"
                                            size="medium"
                                            v-model="form.EffectivityTime"
                                            type="daterange"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            style="width: calc(100% - 28px);"
                                        ></el-date-picker>
                                    </el-radio>
                                </div>
                                <div class="coupans-way-item">
                                    <el-radio v-model="form.EffectivityDateType" :label="2" @change="EffectivityDateTypeRadio">
                                        领取后当天生效，有效天数
                                        <el-input
                                            :disabled="isRadioValidDisabledDay"
                                            class="way-item-input"
                                            size="medium"
                                            v-model="form.EffectivityDayCount"
                                            placeholder="多少"
                                            style="margin-right: 10px;"
                                        ></el-input>天
                                    </el-radio>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <div class="fixed-submit">
                    <el-button size="small" @click="couponsConfigSaveAndRelease(1)" :loading="submitAllLoading">保存</el-button>
                    <el-button size="small" @click="couponsConfigSaveAndRelease(2)" :loading="submitAllLoading" type="primary">发布</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!-- 添加个人/企业 -->
        <el-drawer
            title=""
            :visible.sync="drawer"
            custom-class="add-drawer"
            :with-header="false"
            ref="drawer"
            size="76%"
            :wrapperClosable="false"
        >
            <div class="demo-drawer__content">
                <el-tabs v-model="addUser" type="card" >
                    <el-tab-pane label="个人" name="personal">
                        <PersonalList ref="getp" @onPersonalSubmit="personalNumberFun"/>
                    </el-tab-pane>
                    <el-tab-pane label="企业" name="enterprise">
                        <EnterpriseList ref="gete" @onPersonalSubmit="personalNumberFun"/>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="demo-drawer__footer">
                <template v-if="addUser == 'personal'">
                    <el-button type="primary" @click="addCouponAccountFun(1)">确 定</el-button>
                    <el-button @click="closeDrawer">取 消</el-button>
                </template>
                <template v-else>
                    <el-button type="primary" @click="addCouponAccountFun(2)">确 定</el-button>
                    <el-button @click="closeDrawer">取 消</el-button>
                </template>
            </div>
        </el-drawer>
        <!-- 添加Excel -->
        <el-dialog 
            :visible.sync="excelShow" 
            :title="execlTitle" 
            width="34%" 
            ref="dialog"
            :show-close="false"
            :close-on-click-modal="false"
            append-to-body
        >
            <div>
                <p>1: 文件上传表头为：用户ID、手机号</p>
                <p>2: 上传格式支持XLS</p>
                <p>3: 文件大小不能超过1M；文件最大的上传条数不能超过10000条</p>
                <p>4: 如上传文件格式校验通过，系统自动开始维护库存，请您稍后于任务管理页面查看维护结果</p>
                <!-- <span class="-el-icon-download"></span> -->
                <p style="margin-bottom: 30px;">5: <span class="downLoadTemplate" @click="downLoadTemplate">下载模板 <span class="el-icon-document"></span></span></p>
                <el-upload
                    ref="upload"
                    :data="tokenData"
                    :action="actionUrl"
                    :file-list="fileList"
                    :on-success="onUploadSuccess"
                    :on-error="onUploadError"
                    :on-change="onUploadChange"
                    :on-remove="onUploadRemove"
                    :limit="1"
                    accept=".csv, .xls,.xslx,.xlsx"
                    :auto-upload="false">
                    <el-button slot="trigger" size="mini" type="primary" :disabled="!isExeclSubmitDisabled">选取文件</el-button>
                </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="submitUpload" :disabled="isExeclSubmitDisabled" :loading="isExeclSubmitLoading">确 定</el-button>
                <el-button size="small" @click="clearFilesFun">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { 
  getStorageToken,
} from '@/utils/store'
import { COUPONS_TYPE } from '@/config/const/common.js'
import PersonalList from './index/personalList'
import EnterpriseList from './index/enterpriseList'
import { mapActions } from "vuex";
import {
    deleteCouponAccount,            //删除用户
    couponsConfig,                  //添加优惠券
} from "@/service/coupons";
  export default {
      components: {
        PersonalList,
        EnterpriseList
    },
    data() {
      return {
        COUPONS_TYPE,
        form: {
            Name: '',       //优惠券名称
            Title: '',      //标题
            CouponType: '', //类型
                UsePermission: '',      //使用权限1 仅众包企业专区, 6 仅自营企业专区
                UseScope: '',           //适用范围1 服务费用, 2 加班费用, 3 交通费用, 4 住宿费用, 5 总费用, 999 其它费用
            CouponMode: '',         //优惠方式
                FullReduceLimitAmount: '',      //满减限制金额
                FullReduceOffAmount: '',        //满减优惠金额
                DiscountRate:'',                //折扣比率
                OffAmount: '',                  //立减金额
            GiveOutMode: '',                //发放方式1. 系统发放， 2.手动领取，3. 活动触发
            TargetUser: '',            //目标用户
            EveryPeopleCount: '',       //每人发放数量
            TotalCount: '',             //总数量
            EveryPeopleLimitCount: '',  //每人限领
            EffectivityDateType:'',     //有效期
                EffectivityTime: [],        //有效期时间
                EffectivityDayCount: '',    //有效天数
        },
        isRadioValidDisabledTime: true,
        isRadioValidDisabledDay: true,
        oraginForm:{},
        rules: {
            // 优惠券名称
            Name:[
                { required: true, message: '请输入优惠券名称', trigger: 'blur' },
            ],
            // 类型
            CouponType:[
                { required: true, message: '请选择优惠券类型', trigger: 'change' },
            ],
            //使用权限
            UsePermission:[
                { required: true, message: '请选择使用权限', trigger: 'change' },
            ],
            //使用范围
            UseScope:[
                { required: true, message: '请选择使用范围', trigger: 'change' },
            ],
            //优惠方式
            CouponMode:[
                { required: true, message: '请选择优惠方式', trigger: 'change' },
            ],
            //发放方式
            GiveOutMode:[
                { required: true, message: '请选择发放方式', trigger: 'change' },
            ],
            //用户目标
            TargetUser:[
                { required: true, message: '请选择用户目标', trigger: 'change' },
            ],
            //每人发放数量
            EveryPeopleCount:[
                { required: true, message: '请输入数量', trigger: 'blur' },
            ],
            //总数量
            TotalCount: [
                { required: true, message: '请输入数量', trigger: 'blur' },
            ],
            //有效期
            EffectivityDateType: [
                { required: true, message: '请选择有效期', trigger: 'change' },
            ],
            //每人限领
            EveryPeopleLimitCount: [
                { required: true, message: '请输入每人限领次数', trigger: 'blur' },
            ]
        },
        activeName: 'add',
        coupansName: '',
        drawer: false,
        addUser: 'personal',
        personalNumber: 0,
        enterpriseNumber: 0,
        //上传
        excelShow: false,
        fileList: [],
        tokenData: {
            Token: getStorageToken(),
        },
        
        actionUrl: '',
        isExeclSubmitDisabled: true,
        isExeclSubmitLoading: false,
        execlTitle: '',

        submitAllLoading: false, //点击保存或发布loading

      };
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if(vm.$route.query.personalNumber != 0 || vm.$route.query.enterpriseNumber != 0) {
                vm.personalNumber = vm.$route.query.personalNumber
                vm.enterpriseNumber = vm.$route.query.enterpriseNumber
                vm.form.TargetUser = 2
            }else{
                vm.form.TargetUser = ''
                vm.$refs.ruleForm.resetFields();
            }
        })
    },
    watch: {
        'form.DiscountRate': {
            handler(val) {
                if(val>=1) {
                    this.form.DiscountRate = ''
                    return this.$message.warning('折扣比率不能大于等于1')
                }
            }
        },
    },
    created() {
      this.oraginForm = JSON.parse(JSON.stringify(this.form))
    },
    methods: {
        ...mapActions('app', [
            'removeTabList'
        ]),
        EffectivityDateTypeRadio(e){
            if(e==1) {
                this.isRadioValidDisabledTime = false
                this.isRadioValidDisabledDay = true
                this.form.EffectivityDayCount = ''
            }else{
                this.isRadioValidDisabledDay = false
                this.isRadioValidDisabledTime = true
                this.form.EffectivityTime = []
            }
        },
        addDrawerBox(type){
            this.drawer=true;
            if(type==1) {
                this.addUser='personal'
            }else {
                this.addUser='enterprise'
            }
            this.$nextTick(() => {
                this.$refs.getp.handleSearch()
                this.$refs.gete.handleSearch()
            })
            
        },
        //添加用户
        addCouponAccountFun(type){
            if(type==1) {
                this.$refs.getp.addCouponAccountPersonalFun()
            }else{
                this.$refs.gete.addCouponAccountPersonalFun()
            }
        },
        personalNumberFun(val){
            this.drawer=false;
            this.personalNumber = val.UserAddedCount
            this.enterpriseNumber = val.CompanyAddedCount
            this.$nextTick(() => {
                this.$refs.getp.handleReset()
                this.$refs.gete.handleReset()
            })
        },
        //关闭drawer
        closeDrawer(){
            this.drawer=false;
            this.$nextTick(() => {
                this.$refs.getp.handleReset()
                this.$refs.gete.handleReset()
            })
        },
        updownExcel(type){
            let url = process.env.NODE_ENV == 'development' ? '/api1' : process.env.VUE_APP_API1;
            this.excelShow = true;
            if(type == 1)  {
                this.execlTitle = '添加个人Execl'
                this.actionUrl = url + '/api/Admin/AccountCouponConfig/ImportCouponUser';
            }else{
                this.execlTitle = '添加企业Execl'
                this.actionUrl = url + '/api/Admin/AccountCouponConfig/ImportCouponCompany';
            }
        },
        onUploadChange(){
            this.isExeclSubmitDisabled = false
        },
        onUploadRemove(){
           this.isExeclSubmitDisabled = true
        },
        //清空上传
        clearFilesFun(){
            this.excelShow = false;
            this.isExeclSubmitDisabled = true;
            this.isExeclSubmitLoading = false;
            this.$refs.upload.clearFiles();
        },
        //上传
        submitUpload() {
            this.$refs.upload.submit();
        },
        //上传成功
        onUploadSuccess(response, file){
            this.isExeclSubmitLoading = true
            const isLt1M = file.size /1024/1024 < 1;
            let name = file.name;
            let type = name.substring(name.lastIndexOf('.')+1);
            let is = type == 'csv' || type == 'xls' || type == 'xslx' || type == 'xlsx'
            this.isExeclSubmitLoading = false
            if(!is) {
                return this.$message.warning('上传格式支持xls，xslx，xlsx格式的文件！')
            }
            if(!isLt1M) {
                return this.$message.warning('文件大小不能超过1M')
            }
            if(response.Result != 1) {
                return this.$message.error(response.Message)
            }
            this.$message.success(response.Message)
            this.personalNumber = response.Data.UserAddedCount
            this.enterpriseNumber = response.Data.CompanyAddedCount
            setTimeout(() => {
                this.clearFilesFun();
            }, 50);
        },
        //上传失败
        onUploadError(err, file, fileList){
            console.log('失败')
            console.log(err)
            console.log(file)
            console.log(fileList)
        },
        IsSelectedTrueFun(type) {
            this.drawer=true;
            if(type==1) {
                this.addUser='personal'
            }else {
                this.addUser='enterprise'
            }
            this.$nextTick(() => {
                this.$refs.getp.IsSelectedFun()
                this.$refs.gete.IsSelectedFun()
            })
        },
        //删除用户
        deleteCouponAccountFun(type) {
            var data = {
                UserType: type,
                Token: getStorageToken(),
                platform: 'pcweb'
            }
            deleteCouponAccount(data).then(res=> {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('删除成功！')
                this.personalNumber = res.Data.UserAddedCount
                this.enterpriseNumber = res.Data.CompanyAddedCount
            })
        },
        //每人发放数量大于5访问
        bigFiveFun(){
            if(this.form.EveryPeopleCount > 5) {
                this.$confirm('是否确认每人发放数量为'+this.form.EveryPeopleCount+'？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    console.log('确定')
                }).catch(() => {
                    this.form.EveryPeopleCount = ''
                });
            }
        },
        //1保存||2发布
        couponsConfigSaveAndRelease(is){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let data = JSON.parse(JSON.stringify(this.form))
                    if(data.CouponMode == 1) {
                        if(!data.FullReduceLimitAmount) {
                            return this.$message.warning('请输入满减限制金额')
                        }
                        if(!data.FullReduceOffAmount) {
                            return this.$message.warning('请输入满减优惠金额')
                        }
                    }else if(data.CouponMode == 2){
                        if(!data.DiscountRate) {
                            return this.$message.warning('请输入折扣比率')
                        }
                    }else if(data.CouponMode == 3) {
                        if(!data.OffAmount) {
                            return this.$message.warning('请输入立减金额')
                        }
                    }
                    if(data.TargetUser == 2) {
                        if(!this.personalNumber && !this.enterpriseNumber) {
                            return this.$message.warning('添加个人和添加企业用户至少完成一项')
                        }
                    }
                    if(data.GiveOutMode == 1) {
                        if(!data.EveryPeopleCount) {
                            return this.$message.warning('每人发放数量不能为0')
                        }
                    }else if(data.GiveOutMode){
                        if(!data.TotalCount) {
                            return this.$message.warning('总数量不能为0')
                        }
                        if(data.TargetUser == 2) {
                            let n = this.personalNumber+this.enterpriseNumber
                            if(data.TotalCount < n) {
                                return this.$message.warning('总数量至少大于等于'+ n +'数值')
                            }
                        }
                        if(data.GiveOutMode == 2) {
                            if(!data.EveryPeopleLimitCount) {
                                return this.$message.warning('每人限领不能为0')
                            }
                        }
                    }
                    if(data.EffectivityDateType == 1) {
                        if(!data.EffectivityTime.length) {
                            return this.$message.warning('请选择有效期时间')
                        }
                        data.EffectivityStartTime = data.EffectivityTime[0]
                        data.EffectivityEndTime = data.EffectivityTime[1]
                    }else if(data.EffectivityDateType == 2){
                        if(!data.EffectivityDayCount) {
                            return this.$message.warning('请输入有效天数')
                        }
                    }
                    delete data.EffectivityTime
                    data.OperationType = is
                    data.Token = getStorageToken()
                    data.platform = 'pcweb'
                    this.confirmSubmitCoupons(data)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        confirmSubmitCoupons(data){
            this.submitAllLoading = true
            couponsConfig(data).then(res => {
                this.submitAllLoading = false
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                if(data.OperationType == 1) {
                    this.$message.success('保存成功！')
                }else{
                    this.$message.success('发布成功！')
                }
                setTimeout(() => {
                    this.removeTabList({
                        id: this.$route.meta.menuId,
                    })
                    this.$router.push('/coupons/couponsList')
                    this.handleReset()
                }, 300)
            }).catch(err => {
                console.error(err)
            })
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.$refs.ruleForm.resetFields();
            this.personalNumber = 0;
            this.enterpriseNumber = 0;
        },
        //下载模板
        downLoadTemplate(){
            let url = process.env.NODE_ENV == 'development' ? '/api1' : process.env.VUE_APP_API1
            window.open(url+'/api/Admin/AccountCouponConfig/GetExcelTemplate');
        },
    }
  };
</script>
<style lang="scss">
    .el-tabs__header {
        margin: 0 0 30px;
    }
    .coupans-way-item {
        display: flex;
        justify-content: left;
        align-content: center;
        margin-top: 10px;
        white-space: nowrap;
        .tips-number {
            position: relative;
            margin-left: 5%;
            margin-right: 5%;
            flex: 1;
            text-align: center;
            background: #F9F9F9;
            line-height: 32px;
            font-size: 14px;
            overflow: hidden;
            transition: All 0.4s ease-in-out;
            -webkit-transition: All 0.4s ease-in-out;
            -moz-transition: All 0.4s ease-in-out;
            -o-transition: All 0.4s ease-in-out;
            border: 1px solid rgba($color: #DCDFE6, $alpha: 0.4);
            border-radius: 4px;
            cursor: pointer;
            span {
                position: absolute;
                right: 10px;
                bottom: -3px;
                cursor: pointer;
                transition: All 0.4s ease-in-out;
                -webkit-transition: All 0.4s ease-in-out;
                -moz-transition: All 0.4s ease-in-out;
                -o-transition: All 0.4s ease-in-out;
                transform: scale(0.8);
                -webkit-transform: scale(0.8);
                -moz-transform: scale(0.8);
                -o-transform: scale(0.8);
                -ms-transform: scale(0.8);
                &:hover {
                    transform: scale(1.2);
                    -webkit-transform: scale(1.2);
                    -moz-transform: scale(1.2);
                    -o-transform: scale(1.2);
                    -ms-transform: scale(1.2);
                }
            }
            
            &:hover {
                border-color: rgba($color: #DCDFE6, $alpha: 1.0);
            }
        }
        .el-button {
            height: 34px;
        }
    }
    .way-item-input {
        margin-left: 10px;
        width: 200px;
    }
    .small-title {
        width: 194%;
        background: #F9F9F9;
        font-size: 14px;
        color: #333333;
        font-weight: 600;
        line-height: 48px;
        padding: 0 30px;
        margin: 20px 0;
    }
    .parcel {
        position: relative;
        span {
            position: absolute;
            line-height: 36px;
            font-size: 14px;
            color: #999999;
            right: 0;
            top: 2px;
            width: 30px;
        }
    }
    .fixed-submit {
        position: fixed;
        right: 50px;
        top: 126px;
    }
    .el-drawer.rtl{
        overflow-y: auto;
    }
    .add-drawer {
        .el-drawer__body {
            padding: 20px;
        }
        .demo-drawer__content {
            display: flex;
            flex-direction: column;
            height: calc(100% - 30px);
            // height: 100%;
        }
        
        .el-drawer__header {
            margin-bottom: -30px;
        }
    }
    .downLoadTemplate {
        cursor: pointer;
    }
    .downLoadTemplate:hover {
        color: #409EFF;
        text-decoration: underline;
    }
</style>